import { useEffect, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MonthlyOntimeDeliveryRateKpi (props){

    const table = "VwDeliveryComplianceMonthly";
    const view = "VwDeliveryComplianceMonthly";

    const { filterValue, onFilterInitialized, onSearchInitialized, onModifyViewSchema } = props;

    const [ api, setApi ] = useState ( null );

    useEffect ( () => {

        if ( api ) {

            api.refresh ();

        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ api ] );


    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    return (
    
        
        <BasicCrudScreenType
            id="MonthlyOntimeDeliveryRateKpi"
            noHeader
            table={table}
            view={view}
            extFilterValue={filterValue}
            onFilterInitialized={onFilterInitialized}
            onModifyViewSchema={onModifyViewSchema}
            onSearchInitialized={onSearchInitialized}
            onApiInitialized={onApiInitialized}
        />

    );

}
export default MonthlyOntimeDeliveryRateKpi;